// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IWZc","field":"styles_field__3zV2u","fieldCol":"styles_fieldCol__WL34W","diffCol":"styles_diffCol__386P1","diff":"styles_diff__3OZUd"};